import request from '../../../../api/request';
import {
  ParticipantsDataResponse,
  FormOptionsDataResponse,
  StudentRiskEvaluationSessionResponse,
} from './types';

export const CEIA = {
  GET_FORM_DATA: () =>
    '/maintainers-portal/student-risk-evaluation-session/form',
  GET_USERS: () =>
    '/maintainers-portal/student-risk-evaluation-session/form/users',
  POST_CREATE_SESSION: () =>
    `/maintainers-portal/student-risk-evaluation-session/form`,
  PUT_UPDATE_SESSION: (srEvaluationSessionId: number) =>
    `/maintainers-portal/student-risk-evaluation-session/form/${srEvaluationSessionId}`,
  GET_VIEW: (srEvaluationSessionId: string) =>
    `/maintainers-portal/student-risk-evaluation-session/form/${srEvaluationSessionId}`,
};

export function getAllUsers(searchText?: string) {
  return request<ParticipantsDataResponse>(CEIA.GET_USERS(), {
    params: { search_text: searchText },
  });
}

/**
 * Obtiene los datos para llenar el filtro en el mantenedor de secciones
 * @returns
 */
export const getFormDataRequest = () => {
  return request<FormOptionsDataResponse>(CEIA.GET_FORM_DATA());
};

export const createSessionRequest = (data: any) => {
  return request<any>(CEIA.POST_CREATE_SESSION(), {
    method: 'POST',
    data,
  });
};

export const getViewRequest = (srEvaluationSessionId: string) => {
  return request<StudentRiskEvaluationSessionResponse>(
    CEIA.GET_VIEW(srEvaluationSessionId),
  );
};

export const updateSessionRequest = (
  data: StudentRiskEvaluationSessionResponse & { id: number },
) => {
  return request<StudentRiskEvaluationSessionResponse>(
    CEIA.PUT_UPDATE_SESSION(data.id),
    {
      method: 'PUT',
      data,
    },
  );
};
